import React, { useState, useEffect, useMemo } from "react";
import FormSupplier from "./FormSupplier";
import { fetchSuppliers, addSupplier, updateSupplier, deleteSupplier } from "../../actions/supplierAction";
import { fetchCities } from "../../actions/regionAction/cityAction";
import { connect } from "react-redux";
import { AlertConfirmModal } from "../../components/Modals/AlertConfirmModal";
import { sortHelper } from "../../utils/helpers/sortHelper";
import { useSearchParams } from "react-router-dom";
import debounce from "lodash/debounce";
import UserAvatar from "../../components/UserAvatar";

const SupplierPage = (props) => {
  const {
    dataSuppliers,
    suppliers,
    isLoading,
    fetchSuppliers,
    addSupplier,
    updateSupplier,
    deleteSupplier,
    fetchCities,
    cities,
  } = props;

  const [perPage, setPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePerPageChange = (value) => {
    setPerPage(value);
    setCurrentPage(1);
  };

  const initialState = {
    id: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    shopname: "",
    image: "",
    image_url: "",
    image_path: "",
    category: "",
    account_holder: "",
    account_number: "",
    bank_name: "",
    city_id: "",
  };
  const [formState, setFormState] = useState(initialState);

  const [isShowModal, setIsShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const searchFromUrl = searchParams.get("search") || "";

  const [filterText, setFilterText] = useState(searchFromUrl);

  const { sortConfig, handleSort, getSortedData } = sortHelper.useSort();
  const openModal = () => {
    setFormState(initialState);
    setIsShowModal(true);
  };
  const closeModal = () => {
    setFormState(initialState);
    setIsShowModal(false);
    setIsEdit(false);
  };
  const handleDelete = (id, reason) => {
    deleteSupplier(id, reason);
  };
  const handleAdd = async () => {
    const success = await addSupplier(formState);
    if (success) document.querySelector("#modal-form .btn-close")?.click();
    return success;
  };
  const handleUpdate = async (_item) => {
    const success = await updateSupplier(formState?.id, formState);
    if (success) document.querySelector("#modal-form .btn-close")?.click();
    return success;
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setFilterText(value);

    if (value) {
      setSearchParams({ search: value });
    } else {
      setSearchParams({});
    }
  };

  useEffect(() => {
    setFilterText(searchFromUrl);
  }, [searchFromUrl]);

  const debouncedFetch = useMemo(
    () =>
      debounce((page, limit, search) => {
        fetchSuppliers(limit, page, search);
      }, 500),
    [fetchSuppliers],
  );
  useEffect(() => {
    debouncedFetch(currentPage, perPage, searchFromUrl);

    return () => {
      debouncedFetch.cancel();
    };
  }, [currentPage, perPage, searchFromUrl, debouncedFetch]);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchFromUrl]);

  useEffect(() => {
    fetchCities(10000, 1, "", "");
  }, [fetchCities]);

  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h1 className="page-title fs-1 text-capitalize">Data Supplier</h1>
              <div className="page-pretitle">master supplier</div>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <div className="btn-list">
                <button
                  type="button"
                  className="btn btn-primary btn-5 d-none d-sm-inline-block"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-form"
                  onClick={openModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-2">
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                  Tambah supplier
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-6 d-sm-none btn-icon"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-form"
                  onClick={openModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-2">
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-deck row-cards">
            <div className="col-12">
              <div className="card">
                <div className="card-table">
                  <div className="card-header ">
                    <div className="row w-full">
                      <div className="col-md-9 col-12">
                        <h3 className="card-title mb-0">Supplier</h3>
                        <p className="text-secondary m-0">Master Supplier</p>
                      </div>
                      <div className="col-md-3 col-12 my-md-0 my-2">
                        <div className="input-group input-group-flat w-auto">
                          {isLoading ? (
                            <span className="input-group-text">
                              <div
                                className="spinner-border spinner-border-sm text-primary text-center"
                                role="status"></div>
                            </span>
                          ) : (
                            <span className="input-group-text">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-1">
                                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                <path d="M21 21l-6 -6" />
                              </svg>
                            </span>
                          )}

                          <input
                            id="advanced-table-search"
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleSearchChange}
                            placeholder="Cari..."
                            value={filterText}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="advanced-table">
                    <div className="table-responsive">
                      <table className="table table-vcenter table-selectable">
                        <thead className="table-header">
                          <tr>
                            <th className="sort-name py-3 w-1">No.</th>
                            <sortHelper.SortableHeader
                              label="Nama"
                              sortKey="name"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />

                            <sortHelper.SortableHeader
                              label="Kategori"
                              sortKey="category"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />

                            <sortHelper.SortableHeader
                              label="Kota"
                              sortKey="city_name"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />

                            <th className="sort-status fw-bold">No HP</th>
                            <th className="sort-status fw-bold">Bank</th>
                            <th className="sort-status fw-bold">No Rekening</th>
                            {/* <th className="sort-status fw-bold">Reseller</th> */}
                            <th
                              className="text-start"
                              style={{
                                width: "25%",
                              }}></th>
                          </tr>
                        </thead>

                        <tbody className="table-tbody">
                          {isLoading
                            ? [...Array(suppliers?.length || 5)]?.map((_, index) => (
                                <tr
                                  key={`loading-${index}`}
                                  style={{
                                    cursor: "loader",
                                  }}>
                                  <td className="sort-name py-4">{(currentPage - 1) * perPage + index + 1}.</td>
                                  {[...Array(6)].map((_, i) => (
                                    <td key={i}>
                                      <div className="placeholder placeholder-lg w-75"></div>
                                    </td>
                                  ))}
                                  <td className="justify-content-start text-start flex-nowrap">
                                    <div
                                      className="placeholder placeholder-lg me-2 "
                                      style={{
                                        width: "40%",
                                      }}></div>
                                    <div
                                      className="placeholder placeholder-lg "
                                      style={{
                                        width: "40%",
                                      }}></div>
                                  </td>
                                </tr>
                              ))
                            : getSortedData(suppliers)?.map((Supplier, index) => (
                                <tr key={Supplier.id}>
                                  <td className="sort-name">{(currentPage - 1) * perPage + index + 1}.</td>
                                  <td data-label="Nama">
                                    <div className="d-flex py-1 align-items-center">
                                      <UserAvatar
                                        fullName={Supplier?.name}
                                        imageUrl={Supplier?.image_path || Supplier?.image}
                                        image_path={Supplier?.image_path || Supplier?.image}
                                        size="md"
                                        className="me-2"
                                        justPhotoView={false}
                                      />

                                      <div className="flex-fill">
                                        <div className="font-weight-medium">{Supplier?.name}</div>
                                        <div className="text-secondary">
                                          <span className="text-reset ">{Supplier?.shopname}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="sort-id">
                                    <span className="badge fw-bold">{Supplier?.category}</span>
                                  </td>
                                  <td className="sort-city">{Supplier?.city_name}</td>
                                  <td className="sort-city">{Supplier?.phone}</td>

                                  <td className="sort-status">{Supplier?.bank_name}</td>
                                  <td className="sort-status">
                                    {Supplier?.account_holder} - {Supplier?.account_number}
                                  </td>
                                  <td>
                                    <div className="btn-list flex-nowrap justify-content-center">
                                      <button
                                        type="button"
                                        className="btn btn-1 bg-secondary-lt"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modal-form"
                                        aria-label={`Edit supplier ${Supplier?.name || ""}`.trim()}
                                        onClick={() => {
                                          setIsEdit(true);
                                          setFormState({
                                            id: Supplier?.id,
                                            name: Supplier?.name,
                                            email: Supplier?.email,
                                            phone: Supplier?.phone,
                                            shopname: Supplier?.shopname,
                                            image: Supplier?.image,
                                            image_url: Supplier?.image,
                                            image_path: Supplier?.image,
                                            category: Supplier?.category,
                                            city_id: Supplier?.city_id,
                                            city_name: Supplier?.city_name,
                                            bank_name: Supplier?.bank_name,
                                            account_number: Supplier?.account_number,
                                            account_holder: Supplier?.account_holder,
                                            address: Supplier?.address,
                                          });
                                          setIsShowModal(true);
                                        }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                          <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                          <path d="M16 5l3 3" />
                                        </svg>{" "}
                                        Edit{" "}
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-1 bg-danger-lt"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modal-alert"
                                        aria-label={`Hapus supplier ${Supplier?.name || ""}`.trim()}
                                        onClick={() => {
                                          setFormState({
                                            id: Supplier?.id,
                                            name: Supplier?.name,
                                            email: Supplier?.email,
                                            phone: Supplier?.phone,
                                            shopname: Supplier?.shopname,
                                            image: Supplier?.image,
                                            image_url: Supplier?.image,
                                            image_path: Supplier?.image,
                                            category: Supplier?.category,
                                            city_id: Supplier?.city_id,
                                            city_name: Supplier?.city_name,
                                            bank_name: Supplier?.bank_name,
                                            account_number: Supplier?.account_number,
                                            account_holder: Supplier?.account_holder,
                                            address: Supplier?.address,
                                          });
                                        }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-trash">
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M4 7l16 0" />
                                          <path d="M10 11l0 6" />
                                          <path d="M14 11l0 6" />
                                          <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                        </svg>{" "}
                                        Hapus
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer d-flex align-items-center">
                      <div className="dropdown">
                        <button className="btn dropdown-toggle" data-bs-toggle="dropdown">
                          <span id="page-count" className="me-1">
                            {perPage}
                          </span>
                          <span>records</span>
                        </button>
                        <div className="dropdown-menu">
                          {[10, 20, 50, 100]?.map((value) => (
                            <button key={value} className="dropdown-item" onClick={() => handlePerPageChange(value)}>
                              {value} records
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="d-flex ">
                        <p className="ms-2 my-auto text-secondary">
                          {dataSuppliers?.per_page} dari <span>{dataSuppliers?.total}</span> <span>data</span>
                        </p>
                      </div>

                      <ul className="pagination m-0 ms-auto">
                        {/* PREV BUTTON */}
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>
                            <svg width="24" height="24" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                              <path d="M15 6l-6 6l6 6" />
                            </svg>
                          </button>
                        </li>

                        {/* PAGE NUMBERS */}
                        {dataSuppliers?.links?.slice(1, -1)?.map((item, index) => {
                          const pageNumber = item.url ? new URL(item.url).searchParams.get("page") : null;

                          return (
                            <li key={index} className={`page-item ${item?.active ? "active" : ""}`}>
                              <button
                                className="page-link"
                                disabled={!pageNumber}
                                onClick={() => pageNumber && setCurrentPage(Number(pageNumber))}>
                                {item.label}
                              </button>
                            </li>
                          );
                        })}

                        {/* NEXT BUTTON */}
                        <li className={`page-item ${currentPage === dataSuppliers?.last_page ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(parseInt(dataSuppliers?.current_page) + 1)}>
                            <svg width="24" height="24" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                              <path d="M9 6l6 6l-6 6" />
                            </svg>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormSupplier
        isShowModal={isShowModal}
        isEdit={isEdit}
        closeModal={closeModal}
        formState={formState}
        setFormState={setFormState}
        handleAdd={handleAdd}
        handleUpdate={handleUpdate}
        cities={cities}
        isLoading={isLoading}
      />

      <AlertConfirmModal
        type="error"
        message={`Menghapus data ${formState?.name}`}
        confirmText="Hapus"
        cancelText="Batal"
        idModal="alert"
        idData={formState?.id}
        onConfirm={(id, reason) => {
          handleDelete(id, reason);
        }}
        onCancel={() => {
          // closeModalDelete();
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataSuppliers: state?.suppliers?.datas,
  suppliers: state?.suppliers?.datas?.data || [],
  cities: state?.regions?.cities?.datas?.data || [],
  isLoading: state?.suppliers?.loading,
});

export default connect(mapStateToProps, {
  fetchSuppliers,
  addSupplier,
  updateSupplier,
  deleteSupplier,
  fetchCities,
})(SupplierPage);
